import { ErrorTypes } from '../declarations';
import {FORM_FIELDS_NAMES, VALIDATION_RULES} from '../enums';

export const ERROR_MESSAGES: Record<ErrorTypes, (...arg: any) => string> = {
  [VALIDATION_RULES.REQUIRED]: () => 'VALIDATION.COMMON.REQUIRED',
  [VALIDATION_RULES.MINLENGTH]: () => 'VALIDATION.COMMON.MINLENGTH',
  [VALIDATION_RULES.MAXLENGTH]: () => 'VALIDATION.COMMON.MAXLENGTH',
  [VALIDATION_RULES.PATTERN]: (name: FORM_FIELDS_NAMES) => {
    if (
      [
        FORM_FIELDS_NAMES.FIRST_NAME,
        FORM_FIELDS_NAMES.LAST_NAME,
        FORM_FIELDS_NAMES.MIDDLE_NAME,
        FORM_FIELDS_NAMES.CITY,
        FORM_FIELDS_NAMES.STREET,
        FORM_FIELDS_NAMES.NAME,
      ].includes(name)
    ) {
      return 'VALIDATION.COMMON.PATTERN.NAME';
    }

    if (
      [
        FORM_FIELDS_NAMES.BUILDING,
        FORM_FIELDS_NAMES.APPARTMENT,
        'district',
        'region',
      ].includes(name)
    ) {
      return 'VALIDATION.COMMON.PATTERN.BUILDING';
    }

    if (
      [FORM_FIELDS_NAMES.TIN, FORM_FIELDS_NAMES.ZIP_CODE, FORM_FIELDS_NAMES.EDRPOU].includes(name)
    ) {
      return 'VALIDATION.COMMON.PATTERN.ONLY_DIGIT';
    }

    if (['description'].includes(name)) {
      return 'VALIDATION.COMMON.PATTERN.PROJECT_DESCRIPTION';
    }

    if (['projectName'].includes(name)) {
      return 'VALIDATION.COMMON.PATTERN.PROJECT_NAME';
    }

    return 'pattern';
  },
};
